<template>
  <div id="nav">
    <v-container text-xs-center>
      <v-layout row wrap justify-center>
        <v-flex xs5>
          <v-btn
            block
            depressed
            large
            color="black"
            to="/"
            class="btn-black mr-2"
          >
            Mapa
          </v-btn>
        </v-flex>
        <v-flex xs5>
          <v-btn
            block
            outline
            large
            color="black"
            to="/chart"
            class="btn-white ml-2"
          >
            Gráficas
          </v-btn>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
export default {
  name: "Navigation",
  props: {}
};
</script>

<style>
#nav {
  background-color: #fff;
}

#nav .btn-white {
  font-family: "Open Sans", sans-serif;
  border-radius: 7px;
  font-weight: 900;
  text-transform: capitalize;
  font-size: 25px;
  height: 56px;
}
#nav .btn-white:hover {
  background-color: #be3117 !important;
  border-color: transparent !important;
  color: #fff !important;
}
#nav .btn-black:hover {
  background-color: #be3117 !important;
  border-color: transparent !important;
  color: #fff !important;
}
#nav .btn-black {
  color: #fff;
  font-family: "Open Sans", sans-serif;
  border-radius: 7px;
  font-weight: 900;
  text-transform: capitalize;
  font-size: 25px;
  height: 56px;
}
</style>
